const caculator = (maxW, minW, maxValue, minValue, input) => {
	const result = minValue + (((maxValue - minValue) / (maxW - minW)) * (input - minW));
	return (result >= minValue) ? result : minValue;
};

export default caculator;



// WEBPACK FOOTER //
// ./src/js/caculator.js